import React from 'react';
import { useTenantBackups } from '../hooks/use-tenant-backups.js';
import TenantBackupsPageView from './tenant-backups-page-view.jsx';

function TenantBackupsPageContainer() {
  const props = useTenantBackups();

  return <TenantBackupsPageView {...props} />;
}

export default TenantBackupsPageContainer;
